export const muxConfig = {
    username: process.env.REACT_APP_MUX_TOKEN_ID,
    password: process.env.REACT_APP_MUX_TOKEN_SECRET
}


export const SERVER = "https://dev.myhealthhub.rally.ca/api/v1"
// export const SERVER = "http://localhost:6001/api/v1"